<template>
  <b-container
    v-if="renderPage"
    fluid="md"
  >
    <b-card title="Cadastro de Cliente">
      <validation-observer
        ref="simpleRules"
        #default="{invalid}"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Nome Completo"
                label-for="v-first-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nome Completo"
                  rules="required"
                >
                  <b-form-input
                    id="v-first-name"
                    v-model="req.name"
                    placeholder="Digite o nome do cliente"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Documento"
                label-for="v-document"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Documento"
                  rules="required|document"
                >
                  <b-form-input
                    id="v-document"
                    v-model="req.tax_id"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    type="text"
                    placeholder="Informe o CPF ou CNPJ"
                    :state="errors.length > 0 ? false : null || showTaxIdError == true ? false : null"
                    @focus="showTaxIdError = false "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="showTaxIdError"
                    class="text-danger"
                  >{{ textTaxIdErrorr }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email"
                label-for="v-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="v-email"
                    v-model="req.email"
                    type="email"
                    placeholder="Email"
                    :state="errors.length > 0 ? false : null || showEmailError == true ? false : null"
                    @focus="showEmailError = false "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="showEmailError"
                    class="text-danger"
                  >{{ textEmailError }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Telefone"
                label-for="v-mobile"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Telefone"
                  rules="required|phone"
                >
                  <b-form-input
                    id="v-mobile"
                    v-model="req.phone"
                    v-mask="['(##) #####-####', '(##) ####-####']"
                    placeholder="Informe o telefone"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              class="d-flex justify-content-center mt-2 "
            >
              <b-button
                :to="{ path: '/clientes' }"
                class="btn-back"
              >
                Voltar
              </b-button>
              <b-button
                type="submit"
                class="btn-save-client"
                variant="info"
                :disabled="invalid"
                @click.prevent="validationForm"
              >
                Cadastrar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-container>
</template>
<script>
import Ripple from 'vue-ripple-directive'

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BContainer,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

import {
  required,
  email,
} from '@validations'

import { newClient } from '@/service/client/client'

import { callLoading } from '@/service/utilities/utilities'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BContainer,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showEmailError: false,
      textEmailError: 'Esse Email já está cadastrado',
      showTaxIdError: false,
      textTaxIdErrorr: 'Esse Documento já está cadastrado',
      req: {
        name: null,
        email: null,
        tax_id: null,
        phone: null,
      },
      renderPage: true,
      required,
      email,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  methods: {
    success() {
      this.$swal({
        title: 'Cliente Cadastrado Com Sucesso',
        icon: 'success',
        timer: '1750',
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    error() {
      this.$swal({
        title: 'Erro na Criação do Link!',
        icon: 'error',
        timer: 1750,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) { this.newClient() }
      })
    },
    async newClient() {
      try {
        callLoading(true, true)
        const response = await newClient(this.req)
        const { status } = response

        if (status === 200) {
          this.success()
          this.$router.push('/clientes')
        } else if (status === 422) {
          const { errors } = response.data
          errors.forEach(error => {
            const { field } = error
            if (field === 'email') { this.showEmailError = true } else if (field === 'tax_id') { this.showTaxIdError = true }
          })
        } else {
          this.error()
        }
      } catch {
        this.error()
      } finally {
        callLoading(false)
      }
    },
  },
}
</script>
<style scoped lang="scss">
  @import "@core/scss/vue/pages/client-style.scss";
</style>
